import styled from 'styled-components';

/*
 * The card the flag-on Xero config page is built from. Matches ExportDefaultsCard (T4-152) token for
 * token, so the page's cards stack consistently with the export defaults card below them (T4-205,
 * spec 038 D6). The design's own card is 8px with wider side padding; moving both to it is a
 * separate follow-up, so do not change one without the other.
 */
export const ConfigPageCard = styled.section`
	margin-top: ${props => props.theme.sys.spacing['600']};
	padding: ${props => props.theme.sys.spacing['600']};
	border: ${props => props.theme.sys.size.borderwidth.thin} solid ${props => props.theme.sys.color.border.decorative};
	border-radius: ${props => props.theme.sys.size.borderradius['2']};
`;
